import { render, staticRenderFns } from "./ModalDocs.vue?vue&type=template&id=1aaab4ee"
import script from "./ModalDocs.vue?vue&type=script&lang=js"
export * from "./ModalDocs.vue?vue&type=script&lang=js"
import style0 from "./ModalDocs.vue?vue&type=style&index=0&id=1aaab4ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports